import DialogAlert from "components/DialogAlert/DialogAlert";
import { Container, Content, Footer } from "components/DialogAlertNotify/styles";
import robotErrorImg from "components/DialogAlertNotify/img/robot_img.svg";
import CustomButton from "components/CustomButton/CustomButton";
import { ListOfCrossings } from "./styles";

const DialogErrorScheduleWithCrossings = ({
    dialog,
    schedulesWithCrossings,
    goToUpdateDuration
}) => {
    const changeTeacher = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        dialog.set(false);
    }
    return (
        <DialogAlert
            show={dialog.value}
            toggleShow={dialog.toggle}>
            <Container gap="15px">
                <Content>
                    <img src={robotErrorImg} alt="Imagen de error inesperado UTP"/>
                    <h3>Cruce de eventos</h3>
                    <p>Existen cruces en la duración de tu evento:</p>
                    <ListOfCrossings className="custom-scrollbar secondary">
                        {schedulesWithCrossings.map((schedule, idx) => (
                            <li key={idx}>{schedule}</li>
                        ))}
                    </ListOfCrossings>
                </Content>
                <Footer>
                    <CustomButton
                        width="170px"
                        variant="quintinary"
                        text="Actualizar duración"
                        onClick={goToUpdateDuration}/>
                    <CustomButton
                        width="170px"
                        variant="quaternary"
                        text="Cambiar docente"
                        onClick={changeTeacher}/>
                </Footer>
            </Container>
        </DialogAlert>
    );
}

export default DialogErrorScheduleWithCrossings;